import { Box, Stack, TextField } from '@mui/material';
import { sentenceCase } from 'change-case';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fCurrency } from '../../../utils/formatNumber';
import { fDate } from '../../../utils/formatTime';
import { getAssetDetail } from '../store/assetActions';

AssetDetailCard.propTypes = {
  recordId: PropTypes.string,
};

export default function AssetDetailCard({ recordId }) {
  const dispatch = useDispatch();
  const { asset } = useSelector((state) => state.assetReducer);

  useEffect(() => {
    dispatch(getAssetDetail(recordId));
  }, [dispatch, recordId]);

  return (
    <>
      {(asset && (
        <>
          <Stack spacing={1}>
            <Box
              sx={{
                display: 'grid',
                p: 3,
                rowGap: 3,
                columnGap: 2,
                gridTemplateColumns: { xs: 'repeat(1, 1fr)', sm: 'repeat(2, 1fr)' },
              }}
            >
              <TextField name="assetTag" label="Asset Tag" value={asset?.asset_tag} disabled />
              <TextField name="asset" label="Name" value={asset?.name} disabled />
              <TextField name="branch" label="Location" value={asset?.location?.name} disabled />
              <TextField name="department" label="Department" value={asset?.department || '—'} disabled />
              <TextField name="category" label="Category" value={asset?.category?.name} disabled />
              <TextField name="serialNumber" label="Serial Number" value={asset?.serial_number} disabled />
              <TextField name="barcodeNumber" label="Barcode Number" value={asset?.barcode_number} disabled />
              <TextField name="section" label="Disposed" value={(asset?.disposed && 'Yes') || 'No'} disabled />
              <TextField name="purchaseDate" label="Purchase Date" value={fDate(asset?.purchase_date)} disabled />
              <TextField name="purchaseCost" label="Purchase Cost" value={fCurrency(asset?.purchase_cost)} disabled />
              <TextField
                name="purchaseCost"
                label="Depreciation Start Date"
                value={fDate(asset?.depreciation_start_date)}
                disabled
              />
              <TextField
                name="purchaseCost"
                label="Depreciation End Date"
                value={fDate(asset?.depreciation_end_date)}
                disabled
              />
              <TextField
                name="condition"
                label="Condition"
                value={asset?.condition && sentenceCase(asset?.condition)}
                disabled
              />
              <TextField name="status" label="Status" value={asset?.status && sentenceCase(asset?.status)} disabled />
              <TextField name="custodian" label="Custodian" value={asset?.custodian_name} disabled />
              <TextField
                name="custodian"
                label="Responsible Employee No"
                value={asset?.responsible_staff_number}
                disabled
              />
              <TextField
                name="custodian"
                label="Responsible Employee Name"
                value={asset?.responsible_staff_name}
                disabled
              />
              <TextField name="custodian" label="Vendor No" value={asset?.vendor_number} disabled />
              <TextField name="custodian" label="Vendor Name" value={asset?.vendor_name} disabled />
              <TextField name="hostname" label="Hostname" value={asset?.hostname} disabled />
              <TextField name="ramSize" label="RAM Size (GB)" value={asset?.ram_size} disabled />
              <TextField name="diskSize" label="Disk Size (GB)" value={asset?.disk_size} disabled />
              <TextField name="processor" label="Processor" value={asset?.processor} disabled />
              <TextField name="model" label="Model" value={asset?.model} disabled />
              <TextField name="assignedDate" label="Assigned Date" value={fDate(asset?.assigned_date)} disabled />
              <TextField name="macAddress" label="MAC Address" value={asset?.mac_address} disabled />
              <TextField name="description" label="Description" value={asset?.description} disabled />
              {asset?.has_warranty && (
                <TextField name="warranty" label="Warranty(Year)" value={asset?.warranty} disabled />
              )}
            </Box>
          </Stack>
        </>
      )) ||
        'Asset details will appear here'}
    </>
  );
}
